<script setup lang="ts">
  import { type SelectRenderTag, NTag } from 'naive-ui'

  import { useUsersSelectOptions } from '../model/useUsersSelectOptions'

  const modelValue = defineModel<string[]>({ default: () => [] })

  const { t } = useI18n()

  const usersSelectBindings = useUsersSelectOptions(modelValue)

  const renderTag: SelectRenderTag = ({ option, handleClose }) => {
    return h(
      NTag,
      {
        type: option.type as 'success' | 'warning' | 'error',
        closable: true,
        onMousedown: (e: FocusEvent) => e.preventDefault(),
        onClose: (e: MouseEvent) => {
          e.stopPropagation()
          handleClose()
        },
        color: {
          color: 'var(--color-silver-200)',
          textColor: 'var(--color-primary)',
        },
        class: 'text-[13px]!', // вшитые наив стили перебивают даже themeOverrides тут
        themeOverrides: {
          closeIconColor: 'var(--color-icon-placeholder)',
          border: '0',
        },
      },
      { default: () => option.label },
    )
  }
</script>

<template>
  <NSelect
    v-model:value="modelValue"
    v-bind="usersSelectBindings"
    data-testid="users-select"
    multiple
    clearable
    max-tag-count="responsive"
    :placeholder="t('base_select_users')"
    :render-tag="renderTag"
  />
</template>
